import React from "react";
import "./Programs.css";
import { programsData } from "../../data/programsData.js";
import RightArrow from '../../assets/rightArrow.png';

const Programs = () => {
  return (
    <div className="Programs" id="programs">
      <div className="p-header">
        <span className="outline-text">Discover </span>
        <span>Programs </span>
        <span className="outline-text">shaping your development</span>
      </div>

      <div className="program-cat">
        {programsData.map((program) => (
          <div className="category">
            {program.image}
            <span>{program.heading}</span>
            <span>{program.details}</span>
            <div className="join">
              <span>Join Now</span>
              <img src={RightArrow} alt=""/>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Programs;
